import { ofetch } from 'ofetch'
import { setActivePinia } from 'pinia'
import { resolveApiBaseUrl } from './resolveApiBaseUrl'

const forceClearClientState = () => {
  // Pulisce i cookie gestiti lato frontend; quelli HttpOnly rimangono gestiti dal server
  const cookieNames = [
    'accessToken',
    'userData',
    'userRole',
    'userAbilityRules',
    'userProfile',
    'XSRF-TOKEN',
  ]

  cookieNames.forEach(name => {
    try {
      const cookie = useCookie(name, { default: () => null })

      cookie.value = null
    }
    catch (error) {
      console.error(`[auth] impossibile pulire il cookie ${name}`, error)
    }
  })

  // Pulisce i dati persistiti nel browser per evitare residui di sessione
  try {
    if (typeof localStorage !== 'undefined')
      localStorage.clear()
    if (typeof sessionStorage !== 'undefined')
      sessionStorage.clear()
  }
  catch (error) {
    console.error('[auth] impossibile pulire lo storage', error)
  }
}

export const $api = ofetch.create({
  // Usa il base URL se impostato, altrimenti lascia vuoto per evitare doppi /api
  baseURL: resolveApiBaseUrl(import.meta.env.VITE_API_BASE_URL ?? ''),
  credentials: 'include',
  headers: {
    Accept: 'application/json',
  },
  responseType: 'json',
  async onRequest({ options }) {
    console.log('API Request:', options.baseURL ?? resolveApiBaseUrl(import.meta.env.VITE_API_BASE_URL ?? ''), options)
    
    const headers = new Headers(options.headers ?? {})

    headers.set('Accept', 'application/json')
    headers.set('X-Requested-With', 'XMLHttpRequest')

    const accessToken = useCookie('accessToken').value
    if (accessToken)
      headers.set('Authorization', `Bearer ${accessToken}`)

    options.headers = headers
  },
  async onResponseError({ response }) {
    if (response?.status !== 401)
      return

    // Pulisci lo stato auth e rimanda alla login con redirect
    const [{ router }, { store }, { useAuthStore }] = await Promise.all([
      import('@/plugins/1.router'),
      import('@/plugins/2.pinia'),
      import('@/stores/auth'),
    ])

    setActivePinia(store)

    const authStore = useAuthStore(store)

    authStore.clearAuthState()
    forceClearClientState()

    const redirect = router.currentRoute?.value?.fullPath ?? '/'

    router.replace({ name: 'login', query: { redirect } })
  },
})
